import React from "react";
import PropTypes from "prop-types";

/**
 * Icons that can easily be reused in all the project
 */
const AddIcon = ({ size, color, marginRight, ...props }) => (
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 12 12"
    xmlSpace="preserve"
    width={`${size}`}
    height={`${size}`}
    style={{ marginRight }}
    {...props}
  >
    <path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill={color} />
  </svg>
);

AddIcon.propTypes = {
  /**
   * What background color to use
   */
  color: PropTypes.string,
  /**
   * How large should the icon be?
   */
  size: PropTypes.number,
  /**
   * Margin at the right of the icon
   */
  marginRight: PropTypes.number
};

AddIcon.defaultProps = {
  color: "#ffffff",
  size: 20,
  marginRight: 0
};

export default AddIcon;
